import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PhotoGallery = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showFullscreen, setShowFullscreen] = useState(false);

  const handlePrevious = () => {
    setSelectedIndex((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <div className="bg-card rounded-lg shadow-card p-6 mb-6">
        <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Image" size={24} color="var(--color-primary)" />
          Galería de Fotos
        </h2>

        {/* Main Image */}
        <div className="relative bg-muted rounded-lg overflow-hidden mb-4" style={{ height: '400px' }}>
          <Image
            src={images?.[selectedIndex]?.url}
            alt={images?.[selectedIndex]?.alt}
            className="w-full h-full object-cover cursor-pointer"
            onClick={() => setShowFullscreen(true)}
          />
          
          {/* Navigation Arrows */}
          {images?.length > 1 && (
            <>
              <button
                onClick={handlePrevious}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center transition-colors"
                aria-label="Imagen anterior"
              >
                <Icon name="ChevronLeft" size={24} color="#FFFFFF" />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center transition-colors"
                aria-label="Siguiente imagen"
              >
                <Icon name="ChevronRight" size={24} color="#FFFFFF" />
              </button>
            </>
          )}

          {/* Image Counter */}
          <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
            {selectedIndex + 1} / {images?.length}
          </div>
        </div>

        {/* Thumbnail Navigation */}
        <div className="grid grid-cols-5 gap-2">
          {images?.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`relative rounded-lg overflow-hidden transition-all ${
                index === selectedIndex
                  ? 'ring-2 ring-primary scale-105' :'opacity-70 hover:opacity-100'
              }`}
              style={{ height: '80px' }}
            >
              <Image
                src={image?.url}
                alt={image?.alt}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>
      {/* Fullscreen Modal */}
      {showFullscreen && (
        <div className="fixed inset-0 bg-black z-[2000] flex items-center justify-center" onClick={() => setShowFullscreen(false)}>
          <button
            onClick={() => setShowFullscreen(false)}
            className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors z-10"
            aria-label="Cerrar"
          >
            <Icon name="X" size={24} color="#FFFFFF" />
          </button>
          
          <div className="relative w-full h-full flex items-center justify-center p-4">
            <Image
              src={images?.[selectedIndex]?.url}
              alt={images?.[selectedIndex]?.alt}
              className="max-w-full max-h-full object-contain"
            />
            
            {images?.length > 1 && (
              <>
                <button
                  onClick={(e) => { e?.stopPropagation(); handlePrevious(); }}
                  className="absolute left-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                  aria-label="Imagen anterior"
                >
                  <Icon name="ChevronLeft" size={28} color="#FFFFFF" />
                </button>
                <button
                  onClick={(e) => { e?.stopPropagation(); handleNext(); }}
                  className="absolute right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                  aria-label="Siguiente imagen"
                >
                  <Icon name="ChevronRight" size={28} color="#FFFFFF" />
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoGallery;